export default "__VITE_ASSET__CSbRWNxK__"